import RiscoCardiovascular from '../pages/RiscoCardiovascular/Index'
import RiscoCardiovascularPorEquipeAcs from '../pages/RiscoCardiovascular/PorEquipeAcs'
import RiscoCardiovascularPorProfissional from '../pages/RiscoCardiovascular/PorProfissional'

export default [
  {
    path: '/risco-cardiovascular',
    component: () => import('@/pages/RiscoCardiovascular/Template.vue'),
    children: [
      {
        path: '/risco-cardiovascular',
        component: RiscoCardiovascular,
      },
      {
        path: '/risco-cardiovascular/profissional',
        component: RiscoCardiovascularPorProfissional,
      },
      {
        path: '/risco-cardiovascular/equipe/acs',
        component: RiscoCardiovascularPorEquipeAcs,
      },
    ],
  },
]
